<div class="app-rating">
	<div class="rating-source">
		<p>TrustPilot</p>
	</div>
	<div class="rating">
		<div *ngFor="let star of starArray"><i class="fa {{ star }} star"></i></div>
		<span class="numeric-rating" *ngIf="rating > 0">{{ rating }} out of 5</span>
	</div>
</div>